<div class="container-fluid">
  <h1 class="h3 mb-2 text-gray-800">{{ requestedBookI18n?.allTitleI18n }}</h1>
  
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <!-- Page Heading -->
    

    <!-- DataTales Example -->
    <div class="card shadow mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <app-add-button [itemI18n]="requestedBookI18n"></app-add-button>
          <app-requested-book-list
            (idEvent)="edit($event)"
            (viewEvent)="view($event)"
            (deleteEvent)="delete($event)"
            [requiredBook]="requiredBook$"
            [requestedBookI18n]="requestedBookI18n"
          ></app-requested-book-list>
          <app-requested-book-modal
            [requestedBookI18n]="requestedBookI18n"
            [id]="id"
          ></app-requested-book-modal>
        </div>
      </div>
    </div>
  </ng-template>
</div>
<!-- /.container-fluid -->
